import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import CancelButton from '~/components/core/Buttons/CancelButton';
import type { ResolveItemPath } from '~/components/hooks/traverseErrors';
import {
  useFormikValidationErrorToast,
  ValidationErrorToastContainer,
} from '~/components/hooks/useFormikValidationErrorToast';

import { CONFIGURATIONS_TEXTS as TEXTS } from './texts';

type ClaimBarConfigurationsFooterProps = {
  onCancel: () => void;
  onSave: () => void;
  isCancelDisabled: boolean;
  isSaveDisabled: boolean;
  resolveErrorPath: ResolveItemPath;
};

const ERRORS_TOAST_ID = 'claim-bar-configuration-form-errors';

/**
 * The page's one Cancel and Save, in the sticky footer the FNOL, Policy and LOB configuration screens use. A Save the
 * form refuses lists the errors in their toast, so a field whose card is collapsed or scrolled away is named too.
 */
const ClaimBarConfigurationsFooter = ({
  onCancel,
  onSave,
  isCancelDisabled,
  isSaveDisabled,
  resolveErrorPath,
}: ClaimBarConfigurationsFooterProps) => {
  useFormikValidationErrorToast({ toastId: ERRORS_TOAST_ID, resolveItemPath: resolveErrorPath });

  return (
    <>
      <ValidationErrorToastContainer containerId={ERRORS_TOAST_ID} />
      <div className="fixed bottom-0 left-0 h-80 w-full bg-white shadow-xl">
        <div className="mx-20 flex h-full items-stretch justify-center">
          <div>
            <CancelButton
              onClick={onCancel}
              disabled={isCancelDisabled}
              classNameOverride="my-20"
              content={TEXTS.cancel}
            />
            <Button disabled={isSaveDisabled} onClick={onSave} variant="contained" color="primary" className="my-20">
              {TEXTS.save}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimBarConfigurationsFooter;
